export default __webpack_public_path__ + "static/media/image25.86721660.jpg";